module.exports = __webpack_public_path__ + "static/media/video.3f621b12.svg";